// extracted by mini-css-extract-plugin
export default {"root":"PMXlK8","shadow":"B92WbE","leftTop":"t7ZndO","rightTop":"PI3eKR","centerTop":"NZ1wpF","bg":"dG67Uv"};